export default {
  app: {
    name: 'CargoWare X',
    description: 'CargoWare X System'
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info'
  },
  nav: {
    home: 'Home',
    dashboard: 'Dashboard',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout'
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    username: 'Username',
    password: 'Password',
    loginSuccess: 'Login Success',
    loginFailed: 'Login Failed',
    logoutSuccess: 'Logout Success',

    // Tenant Selection Modal
    tenantSelect: {
      title: 'Select Tenant',
      desc: 'Please select the enterprise tenant you want to login to',
      label: 'Select Enterprise',
      selectPlaceholder: 'Please select enterprise tenant',
      cancel: 'Cancel',
      confirm: 'Confirm',
      error: 'Please select enterprise tenant'
    },

    // Tenant Login Page
    tenantLogin: {
      title: 'Smart Logistics Control Tower',
      subtitle: 'Global Logistics Intelligent Management Platform',
      backToHome: 'Back to Home',

      // Login Related
      login: {
        welcome: 'Welcome Back',
        description: 'Login to your account and start your smart logistics journey',
        globalNetwork: 'Global Network',
        networkDescription: 'Connect to 200+ countries and regions worldwide, providing one-stop logistics solutions',
        passwordLogin: 'Password Login',
        codeLogin: 'Code Login',
        accountLabel: 'Email or Phone',
        accountPlaceholder: 'Please enter email or phone',
        phoneLabel: 'Phone or Email',
        phonePlaceholder: 'Please enter phone or email',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Please enter password',
        codeLabel: 'Verification Code',
        codePlaceholder: 'Please enter verification code',
        rememberMe: 'Remember Me',
        forgotPassword: 'Forgot Password?',
        loginButton: 'Login Now',
        loggingIn: 'Logging in...',
        sendCode: 'Send Code',
        resendAfter: 's',
        otherMethods: 'Other Login Methods'
      },

      // Register Related
      register: {
        title: 'Create Account',
        description: 'Register to become our user and enjoy professional logistics services',
        joinUs: 'Join Us',
        joinDescription: 'Start your smart logistics journey and experience efficient and convenient freight management',
        usernameLabel: 'Username',
        usernamePlaceholder: 'Please enter username',
        phoneLabel: 'Phone',
        phonePlaceholder: 'Please enter phone number',
        phoneCodeLabel: 'Phone Verification Code',
        phoneCodePlaceholder: 'Please enter verification code',
        emailLabel: 'Email (Optional)',
        emailPlaceholder: 'Please enter email (optional)',
        passwordLabel: 'Set Password',
        passwordPlaceholder: 'At least 6 characters',
        confirmPasswordLabel: 'Confirm Password',
        confirmPasswordPlaceholder: 'Please enter password again',
        agreementPrefix: 'I have read and agree to',
        userAgreement: 'User Agreement',
        and: 'and',
        privacyPolicy: 'Privacy Policy',
        registerButton: 'Register Now',
        registering: 'Registering...',
        sendCode: 'Send Code',
        resendAfter: 's',
        enterpriseUserTip: 'Enterprise User?',
        enterpriseUserDesc: 'Please contact your enterprise administrator or',
        staffLogin: 'Use Staff Portal'
      },

      // Switch Related
      switch: {
        noAccount: 'Don\'t have an account?',
        hasAccount: 'Already have an account?',
        register: 'Register Now',
        login: 'Login Now'
      },

      // Forgot Password
      forgotPassword: {
        title: 'Reset Password',
        description: 'Reset your account password via verification code',
        accountLabel: 'Account Information',
        accountPlaceholder: 'Please enter phone or email',
        codeLabel: 'Verification Code',
        codePlaceholder: 'Please enter 6-digit code',
        newPasswordLabel: 'New Password',
        newPasswordPlaceholder: 'Please enter new password (at least 6 characters)',
        confirmPasswordLabel: 'Confirm New Password',
        confirmPasswordPlaceholder: 'Please enter new password again',
        sendCode: 'Send Code',
        resendAfter: 's',
        cancel: 'Cancel',
        confirm: 'Confirm Reset',
        resetting: 'Resetting...',
        successMessage: 'Password reset successfully!',
        failedMessage: 'Password reset failed, please try again'
      },

      // Account Exists
      accountExists: {
        title: 'Account Already Registered',
        description: 'This account has been registered in the system',
        mainTitle: 'Account Already Exists',
        content: 'The phone number or email you entered has already been registered. Please login directly or use another account to register.',
        tipTitle: 'Tip',
        tipContent: 'If you forgot your password, you can use the "Forgot Password" feature on the login page to recover it.',
        cancel: 'Continue Registration',
        goToLogin: 'Go to Login'
      },

      // Messages
      messages: {
        loginSuccess: 'Login successful!',
        loginFailed: 'Login failed, please check your credentials',
        registerSuccess: 'Registration successful!',
        registerFailed: 'Registration failed, please try again',
        codeSent: 'Verification code sent',
        codeFailed: 'Failed to send verification code',
        enterAccountFirst: 'Please enter your account first',
        enterPhoneFirst: 'Please enter your phone number first',
        enterValidPhone: 'Please enter a valid phone number',
        passwordMismatch: 'Passwords do not match',
        personalLoginSuccess: 'Personal account login successful',
        enterpriseLoginSuccess: 'Enterprise account login successful',
        enterAccount: 'Please enter account',
        enterPassword: 'Please enter password',
        enterCode: 'Please enter verification code',
        enterUsername: 'Please enter username',
        enterValidPhoneNumber: 'Please enter a valid phone number',
        passwordMinLength: 'Password must be at least 6 characters',
        passwordNotMatch: 'Passwords do not match',
        agreeToTerms: 'Please agree to the user agreement and privacy policy',
        enterPhoneOrEmail: 'Please enter phone number or email first',
        codeSentSuccess: 'Verification code sent 📱',
        noDomainConfigured: 'Redirect failed, please try again. The current tenant has no domain configured'
      }
    },

    // Policy Modal
    policy: {
      agreement: {
        title: 'User Agreement',
        heading: 'User Agreement',
        welcome: 'Welcome to our smart logistics platform. Please read the following user agreement terms carefully.',
        content: 'By registering and using this platform, you agree to comply with all terms and conditions of this agreement.'
      },
      privacy: {
        title: 'Privacy Policy',
        heading: 'Privacy Policy',
        welcome: 'We take your privacy very seriously. This privacy policy explains how we collect, use and protect your personal information.',
        content: 'We promise to protect the security of your personal information and will not disclose your information to third parties without your consent.'
      },
      closeButton: 'Got it'
    },

    // Portal Header
    portalHeader: {
      backToHome: 'Back to Home',
      loginRegister: 'Login/Register'
    },

    // SSO Authorization Login
    sso: {
      // Authorization Page
      authLogin: 'Authorization Login',
      authDescription: 'Login with your {provider} account',
      usernameLabel: 'Account',
      usernamePlaceholder: 'Please enter your account',
      usernameRequired: 'Please enter your account',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Please enter your password',
      passwordRequired: 'Please enter your password',
      passwordError: 'Password is incorrect',
      authButton: 'Authorize Now',
      authorizing: 'Authorizing...',
      authAgreement: 'By authorizing, you agree to {provider}\'s terms of service',
      back: 'Back',
      backToLogin: 'Back to Login',

      // Tenant Selection Modal
      selectTenant: 'Select Tenant',
      selectTenantDesc: 'Please select the enterprise tenant you want to login to',
      tenantLabel: 'Select Enterprise',
      tenantPlaceholder: 'Search by enterprise name or ID',
      noMatchResult: 'No matching results',
      cancel: 'Cancel',
      confirmBind: 'Confirm Bind',
      selectTenantError: 'Please select an enterprise tenant',

      // User Verification Modal
      verifyUser: 'Verify User',
      verifyUserDesc: 'Please select a user and enter password to verify',
      selectUserPlaceholder: 'Please select a user',
      verifyLogin: 'Verify and Login',

      // Messages
      loginSuccess: 'Login successful',
      loginFailed: 'Login failed, please check your credentials'
    }
  },
  // 产品演示表单
  demoForm: {
    title: 'Request Product Demo',
    subtitle: 'Fill in the information and we will provide you with a professional product demonstration',
    name: 'Name',
    namePlaceholder: 'Please enter your name',
    company: 'Company',
    companyPlaceholder: 'Please enter company name',
    phone: 'Phone',
    phonePlaceholder: 'Please enter contact phone',
    email: 'Email',
    emailPlaceholder: 'Please enter email address',
    privacyNotice: 'We promise to protect your privacy. Your information is only used for product demonstration appointments and will not be used for other commercial purposes.',
    submitButton: 'Request Demo Now',
    cancelButton: 'Cancel',
    submitSuccess: 'Submitted successfully! We will contact you soon.',
    submitFailed: 'Submission failed. Please try again',
    validation: {
      required: 'Please fill in this field.',
      nameRequired: 'Please enter your name',
      companyRequired: 'Please enter company name',
      phoneRequired: 'Please enter contact phone',
      emailRequired: 'Please enter email address',
      emailInvalid: 'Please enter a valid email address'
    }
  }
}
